module.exports = __webpack_public_path__ + "img/login1.67303ad0.png";